import { TRESPONSE_LotListing, TRecordsVMEmbReceived, TEmbLandingViewDescriptor, ITagBctx } from '@monorepo/types';
import * as moment from 'moment';
import { ModifiersZTableModel } from '../../../table.modifier';
import { TTextCell, TTableOptions, TTableCellTree } from '../../../table.type';

const staticHeaders = [
  {
    type: 'TEXT_CELL',
    text: 'emb_common.EMB_SENT_QTY',
    stickyType: 'RIGHT',
  },
  {
    type: 'TEXT_CELL',
    text: 'emb_common.EMB_DISPATCHED_QTY',
    stickyType: 'RIGHT',
  },
  {
    type: 'TEXT_CELL',
    text: 'emb_common.ACTION',
    stickyType: 'RIGHT',
  },
  {
    type: 'TEXT_CELL',
    text: 'emb_common.ACTION',
    stickyType: 'RIGHT',
  },
];

const createHeaderRow = (table_header: TEmbLandingViewDescriptor['table_header']): TTableOptions['headerConfig'] => {
  const HeaderRow = [
    ...table_header.map((field) => ({
      type: 'TEXT_CELL',
      text: field.d,
    })),
    ...staticHeaders,
  ] as TTextCell[];
  return HeaderRow;
};

const staticRowItems = [
  {
    type: 'ACTION_CELL',
    actionType: 'EDIT',
  },
  {
    type: 'ACTION_CELL',
    actionType: 'DELETE',
    customTxt: 'emb_common.remove',
  },
];

const createRowItems = (
  item: TRecordsVMEmbReceived['records'][number],
  table_header: TEmbLandingViewDescriptor['table_header'],
  vendor_key: TEmbLandingViewDescriptor['vendor_key'],
): TTableCellTree[] => {
  return [
    ...table_header.map((field) => ({
      type: 'TEXT_CELL',
      text: field.v === vendor_key ? item.tagDTO.vendorDs : item.tagDTO.quickTagInfo[field.v as ITagBctx['k']] || '--',
    })),
    {
      type: 'TEXT_CELL',
      text: item.tagDTO.sentQty,
    },
    {
      type: 'TEXT_CELL',
      text: item.resolvedQuantityInfo.updatedDispatchQty,
    },
    ...(staticRowItems as TTableCellTree[]),
  ] as TTableCellTree[];
};

export const EMBELLISHMENT_OUT_BULK_TAG_EDIT = {
  createModel: (
    records: TRecordsVMEmbReceived['records'],
    table_header: TEmbLandingViewDescriptor['table_header'],
    vendor_key: TEmbLandingViewDescriptor['vendor_key'],
  ) => {
    console.log('createModel', vendor_key, records, table_header);
    return ModifiersZTableModel.createTableModel(
      records,
      {
        headerConfig: createHeaderRow(table_header),
      },
      (item) => {
        return {
          type: 'ROW',
          rowItem: item,
          cells: createRowItems(item, table_header, vendor_key).map((cell) => ({
            ...cell,
          })),
        };
      },
    );
  },
};
